module.exports = __webpack_public_path__ + "50f403c234d45761903bc58b7af4ddd4.MP3";